import styled from 'styled-components';

/**
 * The Young Crews of one row. A long list of crews would push the other columns
 * out of shape, so they are set as chips that wrap inside their own cell.
 */
export const CrewList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 44rem;
`;

export const CrewChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.gray['200']};
  color: ${({ theme }) => theme.colors.gray['600']};
`;

/** A select does not need the width of the whole form. */
export const NarrowInput = styled.div`
  max-width: 24rem;
  width: 100%;
`;

/** The row of buttons that ends the add / edit form. */
export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 20px 24px;
`;

/**
 * The actions of one table row, side by side - the same ButtonAction pair the
 * reports tables use, so a row reads the same wherever it is.
 */
export const RowActions = styled.div`
  display: flex;
  align-items: center;

  a {
    vertical-align: top;
  }

  span {
    margin-left: 8px;
    line-height: 17px;
  }
`;

/** Note replacing a table or a picker that has nothing to offer. */
export const EmptyNote = styled.p`
  margin: 12px 0 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray['500']};
`;
